import { c as _c } from "react/compiler-runtime";
import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { useSphereDialog } from "@components/common/dialog/sphere-dialog-provider";
import { useFileUploadContext } from "@context-providers/file-upload/file-uploads-context";
import { Text } from "@flat-ui";
import { useCallback } from "react";

/**
 * Type of the callback returned by the hook
 *
 * @param id The id of the upload task to cancel
 */

/**
 * @returns This hook returns a function to cancel a given file upload task.
 *
 */
export function useCancelUpload() {
  const $ = _c(3);
  const {
    uploadManager
  } = useFileUploadContext();
  const {
    createDialog
  } = useSphereDialog();
  let t0;
  if ($[0] !== createDialog || $[1] !== uploadManager) {
    t0 = async id => {
      const hasAccepted = await createDialog({
        title: "Cancel Upload?",
        isHideClose: true
      }, <Text variant="bodyM" sx={{
        marginTop: "0px",
        marginBottom: SPACE_ELEMENTS_OF_MODAL
      }}>Are you sure you want to cancel the upload?<br />You have to select the file again if you want to re-upload.</Text>);
      if (hasAccepted) {
        return uploadManager.cancelFileUpload(id);
      }
      return false;
    };
    $[0] = createDialog;
    $[1] = uploadManager;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const cancelFn = t0;
  return cancelFn;
}